export const rtlLanguageList = ['AR', 'FA', 'KD', 'PS', 'KU'];



// WEBPACK FOOTER //
// ./src/constants/language.js